import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NavigationEnd, Router } from '@angular/router';

import { DialogEnum } from '../DialogEnum';
import { IDialogModel } from '../IDialogModel';

@Component({
  selector: 'app-sucess-dialog',
  templateUrl: './sucess-dialog.component.html'
})
export class SucessDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<SucessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: IDialogModel, router: Router) {
    router.events.subscribe(val => { if (val instanceof NavigationEnd) {
      this.dialogRef.close();
    }});

    this.dialogRef.disableClose = true;
  }

  ngOnInit() {
  }

  onCloseConfirm() {
    this.dialogRef.close(DialogEnum.Confirm);
  }
  onCloseCancel() {
    this.dialogRef.close(DialogEnum.Cancel);
  }
}
